import PropTypes from 'prop-types';
var localityPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  metaData: PropTypes.shape({
    state: PropTypes.string,
    postcodes: PropTypes.string
  }).isRequired
});
var regionGroupPropTypes = PropTypes.shape({
  region: localityPropTypes,
  districts: PropTypes.arrayOf(localityPropTypes),
  nearbyDistricts: PropTypes.arrayOf(localityPropTypes)
});
export default localityPropTypes;
export { regionGroupPropTypes };